import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import { formattedDate, formattedTime } from '../../../../utils/date';
import SmallButtonStyled from '../../../../components/Buttons/SmallButtonStyled';
import EditModalComponent from './EditVehicleComment';

const Container = styled.div`
  border-top: 1px solid rgba(40, 56, 144, 0.1);
  margin: 0px 20px 28px;

  & > .header {
    font-size: 10px;
    color: #677b8b;
    display: flex;
    justify-content: space-between;
    padding: 24px 0 16px;
    & > .label {
      font-weight: 700;
      display: flex;
      align-items: center;
    }
    & > .date {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
  & > .text {
    font-size: 14px;
    & p {
      margin: 0;
    }
  }
`;

export default ({ date, vin, hmsId, basic, mutateVehicle }) => {
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const elmRef = useRef();

  const toggleModal = () => setIsOpenEditModal(!isOpenEditModal);

  useEffect(() => {
    if (elmRef.current) elmRef.current.innerHTML = basic || '';
  }, [elmRef, basic]);

  return (
    <>
      <Container>
        <div className='header'>
          <div className='label'>Description generated by AI</div>
          <div className='date'>
            updated {formattedDate(date)} at {formattedTime(date)}
            <SmallButtonStyled onClick={toggleModal}>Edit</SmallButtonStyled>
          </div>
        </div>
        <div className='text' ref={elmRef}></div>
      </Container>
      {Boolean(isOpenEditModal) && (
        <EditModalComponent
          isOpen={true}
          toggleHandler={toggleModal}
          mutate={mutateVehicle}
          text={basic}
          hmsId={hmsId}
          vin={vin}
        />
      )}
    </>
  );
};
